/**
 * MapLegend Component - Legend of the mission map: take-off point, flight area (polygon or circle) or
 * route + corridor, and the optional points-of-interest layer.
 */
import { Layers, MapPin } from 'lucide-react';
import { FLIGHT_AREA_KIND } from '../../lib/flightArea';

export const MapLegend = ({
  hasTakeoff,
  areaKind,
  showCriticalObjects,
  criticalObjects = [],
  language = 'cs',
  labels = {},
}) => {
  const hasArea = areaKind === FLIGHT_AREA_KIND.POLYGON || areaKind === FLIGHT_AREA_KIND.LINE
    || areaKind === FLIGHT_AREA_KIND.CIRCLE;
  const showPoi = showCriticalObjects && criticalObjects.length > 0;
  if (!hasTakeoff && !hasArea && !showPoi) return null;

  return (
    <div className="absolute bottom-6 left-2 z-[1000] bg-white/95 backdrop-blur-sm rounded-lg shadow-md border p-2 text-xs max-w-[180px] pointer-events-none">
      <p className="font-medium text-slate-700 mb-1.5 flex items-center gap-1">
        <Layers className="h-3 w-3" /> {labels.legendTitle || 'Map layers'}
      </p>
      <div className="space-y-1">
        {hasTakeoff && (
          <div className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-full bg-[#1E3A5F] border-2 border-white shadow-sm" />
            <span className="text-slate-600">{labels.legendTakeoff || 'Take-off point'}</span>
          </div>
        )}
        {areaKind === FLIGHT_AREA_KIND.POLYGON && (
          <div className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-sm bg-blue-500/20 border-2 border-blue-600" />
            <span className="text-slate-600">{labels.legendArea || 'Flight area'}</span>
          </div>
        )}
        {areaKind === FLIGHT_AREA_KIND.CIRCLE && (
          <div className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-full bg-blue-500/20 border-2 border-blue-600" />
            <span className="text-slate-600">{labels.legendCircle || 'Flight area (circle)'}</span>
          </div>
        )}
        {areaKind === FLIGHT_AREA_KIND.LINE && (
          <>
            <div className="flex items-center gap-1.5">
              <span className="w-3 h-0 border-t-2 border-dashed border-blue-700" />
              <span className="text-slate-600">{labels.legendRoute || 'Route'}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="w-3 h-3 rounded-full bg-blue-500/30" />
              <span className="text-slate-600">{labels.legendCorridor || 'Corridor'}</span>
            </div>
          </>
        )}
        {showPoi && (
          <div className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-full bg-sky-500/20 border border-sky-500 flex items-center justify-center">
              <MapPin className="w-2 h-2 text-sky-600" />
            </span>
            <span className="text-slate-600">
              {language === 'cs' ? 'Body zájmu' : 'POI'} ({criticalObjects.length})
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapLegend;
